<template>
  <div class="account">
    <GlobalInfoBar title="投保单列表" />
    <GlobalChunk :padding="[20, 20, 20, 20]">
      <GlobalForm :init-data="initData" :form-rules="formRules" :form-item-list="formItemList" :inline="true" round
        @handleConfirm="query" confirmBtnName="查询" :label-width="90">
        <el-form-item class="el_from" label="IMEI:" slot="imei" style="margin:0">
          <el-input v-model="imei" clearable placeholder="请输入IMEI查询"></el-input>
        </el-form-item>
        <el-form-item class="el_from" label="商家名称:" slot="group_name" style="margin:0">
          <el-select
            v-model="group_id"
            placeholder="请输入商家名称"
            filterable
            clearable
          >
            <el-option
              v-for="item in plantmerchantDataList"
              :key="item.group_id"
              :label="item.group_name"
              :value="item.group_id"
            ></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item class="el_from" label="联系电话:" slot="phone" style="margin:0">
          <el-input v-model="phone" clearable placeholder="请输入联系电话查询"></el-input>
        </el-form-item>
        <el-form-item class="el_from" label="订单状态:" slot="status" style="margin:0">
          <el-select clearable v-model="status" placeholder="请选择">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <div slot="AddBtn">
          <el-button type="success" round @click="exportExcel()">下载</el-button>
        </div>
      </GlobalForm>

      <GlobalTable ref="GlobalTable" :columns="tableColumns" :data="tableData" :currentPage="curPage"
        :total="totalElements" @handleCurrentChange="currentChange">
        <el-table-column label="操作" slot="operation" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" @click="handleBtn(row)">查看详情</el-button>

          </template>
        </el-table-column>

      </GlobalTable>
    </GlobalChunk>
  </div>
</template>

<script>
import api from '@/utils/request'
export default {
  name: "account",
  data() {
    return {
      options: [

        {
          value: '0',
          label: '等待移动审核'
        }, {
          value: '1',
          label: '审核通过'
        }, {
          value: '2',
          label: '审核不通过'
        }],
      status: null,
      initData: {},
      formRules: {},
      formItemList: [
        { slotName: "imei" },
        { slotName: "group_name" },
        { slotName: "phone" },
        {
          key: "entryTime",
          type: "daterange",
          labelName: "时间:",
          placeholder: "请选择时间",
          valueFormat: "timestamp",
        },
        { slotName: "status" },
      ],
      imei: '',
      group_id: '', // 商家名称id
      plantmerchantDataList:[], // 搜索商家列表
      phone: '',
      beg_time: '',
      end_time: '',
      tableColumns: [
        { label: "手机号", prop: "phone" },
        { label: "imei", prop: "imei" },
        { label: "品牌", prop: "brandYd" },
        { label: "机型", prop: "modelYd" },
        { label: "内存", prop: "ramlYd" },
        { label: "险种", prop: "card_name" },
        { label: "卡密", prop: "card_secret" },
        { label: "移动产品编码", prop: "somProCode" },
        { label: "商家名称", prop: "group_name" },
        { label: "注册门店", prop: "shop_name" },
        { label: "注册门店员工", prop: "shop_member_name" },
        { label: "注册时间", prop: "add_time" },
        { label: "订单状态", prop: "exa_status" },
        { slotName: 'operation' },
      ],
      tableData: [],
      curPage: 1,
      totalElements: 0,
      pageSize: 10,

      loading: false,
      searchParams: {}
    }
  },
  created() {
    this.getList();
    this.selectGroupList()

  },
  mounted() {

  },
  methods: {
    query(data, cd) {
      cd();
      console.log(data, '11111111');
      if (data) {
        if (data.entryTime === null) {
          (this.beg_time = ""), (this.end_time = "");
        } else {
          this.beg_time = (data.entryTime && data.entryTime[0]) || "";
          this.end_time = (data.entryTime && data.entryTime[1]) || "";
        }
      } else {
        (this.beg_time = ""), (this.end_time = "");
      }
      this.curPage = 1
      this.getList()
    },
    currentChange(page) {
      this.curPage = page
      this.getList()
    },
    getList() {
      let params = {
        page: this.curPage,
        limit: this.pageSize,
        imei: this.imei,
        group_id: this.group_id, // 商家名称id
        phone: this.phone,
        beg_time: this.beg_time,
        end_time: this.end_time,
        status: this.status,
      }
      this.searchParams = params
      api.yidongAcceptList(params).then(res => {
        this.tableData = res.data
        this.totalElements = res.count || 0
      })
    },
    exportExcel() {
      api.yidongDownloadAccept(this.searchParams).then(res => {
        console.log(res)
        const content = res
        const blob = new Blob([content])
        const fileName = '投保单列表.xls'
        if ('download' in document.createElement('a')) {
          // 非IE下载
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
      })
    },
    handleBtn(row) {
      sessionStorage.setItem('orderDetail', JSON.stringify(this.searchParams))
      this.$router.push({
        name: "移动订单详情",
        params: { type: 1, orderId: row.order_id },

      });
    },

    // 获取商家名称列表
    selectGroupList() {
      api.selectGroupList().then((res) => {
        if (res.code === 1) {
          this.plantmerchantDataList = res.data;
        }
      });
    },
  }
}
</script>

<style scoped lang="scss">
.account {
  /deep/ .el-form-item__label {
    width: 80px !important;
  }

  /deep/ .el-form-item__content .el-select {
    width: 200px !important;
  }

  /deep/ .el-form-item__content .el-date-editor {
    // width: 300px !important;
  }
}
</style>
